import React from "react";

const Results = ({ raceInfo, resultsList }) => {
  let Result3 = [];

  //WAGER TYPES RESULTS (Tabla Win Place Show)
  const resultsExoticTable = (wagerType, data) => {
    let table = [],
      tablePicks = [];

    const wagerTypeLabel =
      wagerType.charAt(0).toUpperCase() + wagerType.slice(1);

    if (wagerType.includes("Double")) {
      data.forEach((element, i) => {
        tablePicks.push(
          <div className="form-row mb-2" key={i}>
            <label
              htmlFor="staticEmail"
              className="col-sm-1 lead mt-2 mr-4"
              style={{ fontSize: "16px", fontWeight: "bold" }}
              key={"lbl" + i}
            >
              {wagerTypeLabel}
            </label>
            <div
              className="col-sm-3 mt-2"
              key={"wtd" + i}
              style={{
                verticalAlign: "middle",
                textAlign: "center",
              }}
            >
              {element.Selections || (
                <span
                  style={{
                    color: "#bfbfbf",
                  }}
                >
                  Entries
                </span>
              )}
            </div>
            <div
              className="input-group mt-2"
              style={{
                width: "150px",
                background: "none",
                textAlign: "center",
                color: "#495057",
              }}
              key={"pd" + i}
            >
              <span
                className="mr-2"
                id="inputGroup-sizing-default"
                style={{
                  border: "none",
                  fontWeight: "bold",
                  color: "#bfbfbf",
                }}
              >
                $2
              </span>{" "}
              {element.Payout || (
                <span
                  style={{
                    color: "#bfbfbf",
                  }}
                >
                  Payout
                </span>
              )}
            </div>

            <div
              className="mr-2"
              style={{ width: "180px" }}
              key={"ed" + i}
            ></div>
          </div>
        );
      });
      table.push(<div className="scroll-vertical">{tablePicks}</div>);
    } else {
      if (wagerType.includes("Pick")) {
        data.forEach((element, i) => {
          tablePicks.push(
            <div className="form-row mb-2" key={i}>
              <label
                htmlFor="staticEmail"
                className="col-sm-1 lead mt-2 mr-4"
                style={{ fontSize: "16px", fontWeight: "bold" }}
                key={"lblp" + i}
              >
                {wagerTypeLabel}
              </label>
              <div
                className="col-sm-3 mt-2"
                key={"wtp" + i}
                style={{
                  textAlign: "center",
                  verticalAlign: "middle",
                }}
              >
                {element.Selections || (
                  <span
                    style={{
                      color: "#bfbfbf",
                    }}
                  >
                    Entries
                  </span>
                )}
              </div>
              <div
                className="input-group mt-2"
                style={{
                  width: "150px",
                  background: "none",
                  textAlign: "center",
                  color: "#495057",
                }}
                key={"pd" + i}
              >
                <span
                  className="mr-2"
                  id="inputGroup-sizing-default"
                  style={{
                    border: "none",
                    fontWeight: "bold",
                    color: "#bfbfbf",
                  }}
                >
                  $2
                </span>{" "}
                {element.Payout || (
                  <span
                    style={{
                      color: "#bfbfbf",
                    }}
                  >
                    Payout
                  </span>
                )}
              </div>
              <div
                className="mr-1 mt-2"
                style={{ width: "90px" }}
                key={"cp" + i}
              >
                {element.Correct && (
                  <>
                    <span
                      className="mr-1"
                      id="inputGroup-sizing-default"
                      style={{
                        border: "none",
                        fontWeight: "bold",
                        color: "#bfbfbf",
                        fontSize: "12px",
                      }}
                    >
                      Correct
                    </span>
                    {element.Correct}
                  </>
                )}
              </div>
              <div
                className="mr-1 mt-2"
                key={"ptfp" + i}
                style={{
                  textAlign: "center",
                  verticalAlign: "middle",
                }}
              >
                {element.PTF}
              </div>
            </div>
          );
        });
        table.push(<div className="scroll-vertical">{tablePicks}</div>);
      } else {
        data.forEach((element, i) => {
          table.push(
            <div className="form-row mb-2" key={i}>
              <label
                htmlFor="staticEmail"
                className="col-sm-1 lead mt-2 mr-4"
                style={{ fontSize: "16px", fontWeight: "bold" }}
                key={"lblE" + i}
              >
                {wagerTypeLabel}
              </label>
              <div
                className="col-sm-3 mt-2"
                key={"ee" + i}
                style={{
                  textAlign: "center",
                  verticalAlign: "middle",
                }}
              >
                {element.Selections || (
                  <span
                    style={{
                      color: "#bfbfbf",
                    }}
                  >
                    Entries
                  </span>
                )}
              </div>
              <div
                className="input-group mt-2"
                style={{
                  width: "150px",
                  background: "none",
                  textAlign: "center",
                  color: "#495057",
                }}
                key={"pd" + i}
              >
                <span
                  className="mr-2 "
                  id="inputGroup-sizing-default"
                  style={{
                    border: "none",
                    fontWeight: "bold",
                    color: "#bfbfbf",
                  }}
                >
                  $2
                </span>{" "}
                {element.Payout || (
                  <span
                    style={{
                      color: "#bfbfbf",
                    }}
                  >
                    Payout
                  </span>
                )}
              </div>
              <div
                className="mr-2"
                style={{ width: "180px" }}
                key={"espe" + i}
              ></div>
            </div>
          );
        });
      }
    }

    return table;
  };
  //WAGER TYPES RESULTS (tabla de exóticas)
  if (raceInfo && resultsList.length !== 0) {
    if (raceInfo.Exacta) {
      if (resultsList.Exacta) {
        Result3.push(
          <div className="col" key={4 + "exacta"}>
            {resultsExoticTable("Exacta", resultsList.Exacta)}
          </div>
        );
      }
    }
    if (raceInfo.Trifecta) {
      if (resultsList.Trifecta) {
        Result3.push(
          <div className="col" key={5 + "trifecta"}>
            {resultsExoticTable("Trifecta", resultsList.Trifecta)}
          </div>
        );
      }
    }

    if (raceInfo.Superfecta) {
      if (resultsList.Superfecta) {
        Result3.push(
          <div className="col" key={7 + "superfecta"}>
            {resultsExoticTable("Superfecta", resultsList.Superfecta)}
          </div>
        );
      }
    }

    if (raceInfo.RaceNumber !== 1) {
      if (resultsList.Double) {
        Result3.push(
          <div className="col" key={3 + "double"}>
            {resultsExoticTable("Double", resultsList.Double)}
          </div>
        );
      }
    }

    if (raceInfo.Quinella) {
      if (resultsList.Quinella) {
        Result3.push(
          <div className="col" key={6 + "quinella"}>
            {resultsExoticTable("Quinella", resultsList.Quinella)}
          </div>
        );
      }
    }

    if (raceInfo.Omni) {
      if (resultsList.Omni) {
        Result3.push(
          <div className="col" key={19 + "omni"}>
            {resultsExoticTable("Omni", resultsList.Omni)}
          </div>
        );
      }
    }

    if (raceInfo.RaceNumber !== 1 && raceInfo.RaceNumber !== 2) {
      if (resultsList.Pick3) {
        Result3.push(
          <div className="col" key={8 + "pick3"}>
            {resultsExoticTable("Pick3", resultsList.Pick3)}
          </div>
        );
      }
    }

    if (
      raceInfo.RaceNumber !== 1 &&
      raceInfo.RaceNumber !== 2 &&
      raceInfo.RaceNumber !== 3
    ) {
      if (resultsList.Pick4) {
        Result3.push(
          <div className="col" key={resultsList.Pick4.PoolType + "Pick4"}>
            {resultsExoticTable("Pick4", resultsList.Pick4)}
          </div>
        );
      }
    }

    if (
      raceInfo.RaceNumber !== 1 &&
      raceInfo.RaceNumber !== 2 &&
      raceInfo.RaceNumber !== 3 &&
      raceInfo.RaceNumber !== 4
    ) {
      if (resultsList.Pick5) {
        Result3.push(
          <div className="col" key={resultsList.Pick5.PoolType + "Pick5"}>
            {resultsExoticTable("Pick5", resultsList.Pick5)}
          </div>
        );
      }
    }

    if (
      raceInfo.RaceNumber !== 1 &&
      raceInfo.RaceNumber !== 2 &&
      raceInfo.RaceNumber !== 3 &&
      raceInfo.RaceNumber !== 4 &&
      raceInfo.RaceNumber !== 5
    ) {
      if (resultsList.Pick6) {
        Result3.push(
          <div className="col" key={resultsList.Pick6.PoolType + "Pick6"}>
            {resultsExoticTable("Pick6", resultsList.Pick6)}
          </div>
        );
      }
    }

    if (
      raceInfo.RaceNumber !== 1 &&
      raceInfo.RaceNumber !== 2 &&
      raceInfo.RaceNumber !== 3 &&
      raceInfo.RaceNumber !== 4 &&
      raceInfo.RaceNumber !== 5 &&
      raceInfo.RaceNumber !== 6
    ) {
      if (resultsList.Pick7) {
        Result3.push(
          <div className="col" key={resultsList.Pick7.PoolType + "Pick7"}>
            {resultsExoticTable("Pick7", resultsList.Pick7)}
          </div>
        );
      }
    }

    if (
      raceInfo.RaceNumber !== 1 &&
      raceInfo.RaceNumber !== 2 &&
      raceInfo.RaceNumber !== 3 &&
      raceInfo.RaceNumber !== 4 &&
      raceInfo.RaceNumber !== 5 &&
      raceInfo.RaceNumber !== 6 &&
      raceInfo.RaceNumber !== 7
    ) {
      if (resultsList.Pick8) {
        Result3.push(
          <div className="col" key={resultsList.Pick8.PoolType + "Pick8"}>
            {resultsExoticTable("Pick8", resultsList.Pick8)}
          </div>
        );
      }
    }

    if (
      raceInfo.RaceNumber !== 1 &&
      raceInfo.RaceNumber !== 2 &&
      raceInfo.RaceNumber !== 3 &&
      raceInfo.RaceNumber !== 4 &&
      raceInfo.RaceNumber !== 5 &&
      raceInfo.RaceNumber !== 6 &&
      raceInfo.RaceNumber !== 7 &&
      raceInfo.RaceNumber !== 8
    ) {
      if (resultsList.Pick9) {
        Result3.push(
          <div className="col" key={resultsList.Pick9.PoolType + "Pick9"}>
            {resultsExoticTable("Pick9", resultsList.Pick9)}
          </div>
        );
      }
    }

    if (
      raceInfo.RaceNumber !== 1 &&
      raceInfo.RaceNumber !== 2 &&
      raceInfo.RaceNumber !== 3 &&
      raceInfo.RaceNumber !== 4 &&
      raceInfo.RaceNumber !== 5 &&
      raceInfo.RaceNumber !== 6 &&
      raceInfo.RaceNumber !== 7 &&
      raceInfo.RaceNumber !== 8 &&
      raceInfo.RaceNumber !== 9
    ) {
      if (resultsList.Pick10) {
        Result3.push(
          <div className="col" key={resultsList.Pick10.PoolType + "Pick10"}>
            {resultsExoticTable("Pick10", resultsList.Pick10)}
          </div>
        );
      }
    }

    if (
      raceInfo.RaceNumber !== 1 &&
      raceInfo.RaceNumber !== 2 &&
      raceInfo.RaceNumber !== 3 &&
      raceInfo.RaceNumber !== 4 &&
      raceInfo.RaceNumber !== 5 &&
      raceInfo.RaceNumber !== 6 &&
      raceInfo.RaceNumber !== 7 &&
      raceInfo.RaceNumber !== 8 &&
      raceInfo.RaceNumber !== 9 &&
      raceInfo.RaceNumber !== 10
    ) {
      if (resultsList.Pick11) {
        Result3.push(
          <div className="col" key={resultsList.Pick11.PoolType + "Pick11"}>
            {resultsExoticTable("Pick11", resultsList.Pick11)}
          </div>
        );
      }
    }

    if (
      raceInfo.RaceNumber !== 1 &&
      raceInfo.RaceNumber !== 2 &&
      raceInfo.RaceNumber !== 3 &&
      raceInfo.RaceNumber !== 4 &&
      raceInfo.RaceNumber !== 5 &&
      raceInfo.RaceNumber !== 6 &&
      raceInfo.RaceNumber !== 7 &&
      raceInfo.RaceNumber !== 8 &&
      raceInfo.RaceNumber !== 9 &&
      raceInfo.RaceNumber !== 10 &&
      raceInfo.RaceNumber !== 11
    ) {
      Result3.push(
        <div className="col" key={resultsList.Pick12.PoolType + "Pick12"}>
          {resultsExoticTable("Pick12", resultsList.Pick12)}
        </div>
      );
    }
  }

  //SETEAR RESULTS
  let tableResults = [],
    resultsListWP = [],
    oneResults = {},
    resultList = [];

  if (resultsList.WPSList) {
    resultsList.WPSList.forEach((item, index) => {
      resultList = [];
      oneResults = {};
      switch (item["Pos"]) {
        case 1:
          oneResults.Pos = item["Pos"] + "st";
          break;
        case 2:
          oneResults.Pos = item["Pos"] + "nd";
          break;
        case 3:
          oneResults.Pos = item["Pos"] + "rd";
          break;
        default:
          oneResults.Pos = item["Pos"].toString();
      }
      oneResults.EntryNum = item["Entrynum"].toString();

      oneResults.EntryName = item["Entryname"];

      resultList.push(
        <td key={1}>
          <h5>
            <span>{item["Entryname"]}</span>
          </h5>
        </td>
      );

      oneResults.Win = item["Win"];
      oneResults.Place = item["Place"];
      oneResults.Show = item["Show"];

      if (item["Win"] === 0) {
        oneResults.Win = "";
      }
      if (item["Place"] === 0) {
        oneResults.Place = "";
      }
      if (item["Show"] === 0) {
        oneResults.Show = "";
      }

      resultsListWP.push(oneResults);
    });
  }

  if (resultsListWP) {
    tableResults = resultsListWP.map((data, i) => {
      return (
        <tr key={i}>
          <td style={{ textAlign: "center" }}>{data.Pos}</td>
          <td style={{ textAlign: "center" }}>{data.EntryNum}</td>
          <td style={{ textAlign: "center" }}>{data.EntryName}</td>
          <td style={{ textAlign: "center" }}>{data.Win}</td>
          <td style={{ textAlign: "center" }}>{data.Place}</td>
          <td style={{ textAlign: "center" }}>{data.Show}</td>
        </tr>
      );
    });
  }

  return (
    <>
      <div>
        <div className="" style={{ textAlign: "center" }}>
          <h5
            style={{
              color: "#005580",
            }}
          >
            <span>
              <img src="./images/results.png" alt="" className="mb-1 mr-2" />
            </span>
            R{raceInfo.RaceNumber} Results
          </h5>
        </div>
        <table className="table table-striped table-md">
          <thead>
            <tr
              className="text-center"
              style={{
                color: "#006699",
              }}
            >
              <th hidden>RaceID</th>
              <th>POS</th>
              <th>#</th>
              <th>Entry Name</th>
              <th>Win</th>
              <th>Place</th>
              <th>Show</th>
            </tr>
          </thead>
          <tbody className="table-sm">{tableResults}</tbody>
        </table>
        {Result3}
      </div>
    </>
  );
};

export default Results;
